module.exports = "/_next/static/images/cv-c823e98891ff7685b997a8bf4a13662f.svg";